// extracted by mini-css-extract-plugin
export default {"month":"TaskHistoryDate_month__tCrsH","day":"TaskHistoryDate_day__LBfT0"};